<template>
    <div>
        <s-crud
            :config="config"
            title="Lotes de Declaración"
            :filter="filter"
            search-input
            ref="scrud"
            :single-row="true"
            group-by="StrID"
        >
            <template v-slot:group.header="{ group, items, isOpen, toggle, headers }">
                <td :colspan="headers.length" class="text-start pr-4" style="background-color: #f5f5f5;">
                    <div class="d-flex align-center" style="width: 100%;">
                        <v-btn icon @click="toggle" x-small class="mr-2">
                            <v-icon>{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
                        </v-btn>
                        <span class="font-weight-bold">ID Lote: {{ group }}</span>
                        <span class="ml-4 grey--text text--darken-3 font-weight-medium">| Cliente: {{ items[0].CardName }}</span>
                        <span class="ml-4 grey--text text--darken-3 font-weight-medium" v-if="items[0].StrDate">| Fecha Reg: {{ $fun.formatDateView(items[0].StrDate) }}</span>
                        <v-spacer></v-spacer>

                        <v-btn 
                            small 
                            color="info" 
                            depressed
                            @click.stop="openDetailByItem(items[0])"
                        >
                            <v-icon left small>mdi-file-pdf-box</v-icon>
                            Ver Declaración (PDF)
                        </v-btn>
                    </div>
                </td>
            </template>
            <template v-slot:filter>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="6" md="3">
                            <s-select
                                label="Año"
                                :items="years"
                                outlined
                                hide-details
                                dense
                                v-model="filter.Year"
                            ></s-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <s-periods
                                label="Periodo Mensual"
                                :type="2"
                                v-model="filter.Period"
                                :year="filter.Year"
                                return-object
                            ></s-periods>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </s-crud>

        <!-- Detalle del Lote (Vista PDF) -->
        <v-dialog v-model="dialogDetail" max-width="1000" persistent>
             <p-d-f-additives-declaration 
                v-if="dialogDetail && selectedBatch"
                :data="selectedBatch" 
                @close="dialogDetail = false"
                @save="saveBatchChanges"
            />
        </v-dialog>
    </div>
</template>

<script>
import StatementRegisterService from "../../../services/Sale/StatementRegisterService";
import PDFAdditivesDeclaration from "./PDFAdditivesDeclaration.vue";

export default {
    name: "StatementRegister",
    components: {
        PDFAdditivesDeclaration
    },
    data() {
        return {
            filter: {
                Period: {},
                DateBegin: null,
                DateEnd: null,
                Send: 1,
                ExistC: 1
            },
            years: [],
            config: {
                service: StatementRegisterService,
                model: {
                    DocEntry: "ID",
                    U_SYP_FGUIA: 'date'
                },
                headers: [
                    { text: "Fecha de Guia", value: "U_SYP_FGUIA" },
                    { text: "Contenedor", value: "U_SYP_CONTENEDOR" },
                    { text: "Cliente", value: "CardName" },
                    { text: "Nave", value: "U_SYP_NAVE" },
                    { text: "Viaje", value: "U_SYP_VIAJE" },
                ]
            },
            dialogDetail: false,
            loadingDetail: false,
            selectedBatch: null
        };
    },
    created() {
        this.years = this.$fun.getTop5LastYears();
        this.filter.Year = this.$moment().year();
    },
    methods: {
        async openDetailByItem(item) {
            if (!item) return;
            
            this.loadingDetail = true;
            this.dialogDetail = true;

            try {
                const response = await StatementRegisterService.list(item.StrID, this.$fun.getUserID());
                if (response.status === 200) {
                    const batch = response.data;
                    
                    this.selectedBatch = batch;
                }
            } catch (error) {
                this.$fun.alert("Error al cargar el detalle del lote", "error");
                this.dialogDetail = false;
            } finally {
                this.loadingDetail = false;
            }
        },
        async saveBatchChanges(data) {
            try {
                const response = await StatementRegisterService.save(data, this.$fun.getUserID());
                if (response.status === 200) {
                    this.$fun.alert("Cambios guardados correctamente", "success");
                    this.$refs.scrud.refresh();
                    this.dialogDetail = false;
                }
            } catch (error) {
                this.$fun.alert("Error al guardar los cambios", "error");
            }
        }
    },
    watch: {
        'filter.Period'(newVal) {
            if (newVal) {
                this.filter.DateBegin = newVal.PdsDateBegin || this.$fun.getDate();
                this.filter.DateEnd = newVal.PdsDateEnd || this.$fun.getDate();
            }
        }
    }
};
</script>

<style scoped>
</style>
